import { CIcon } from '~/icons/types'

export const ciTierBadge: CIcon = {
  width: '14',
  height: '22',
  paths: [
    {
      d:
        'M3.246 16.943v3.806a.626.626 0 0 0 .846.586l3.12-1.17 3.12 1.17a.626.626 0 0 0 .846-.586v-3.806a7.717 7.717 0 0 1-3.966 1.092 7.717 7.717 0 0 1-3.966-1.092Zm7.932-13.346V.627A.626.626 0 0 0 10.552 0h-6.68a.626.626 0 0 0-.626.626v2.97a7.718 7.718 0 0 1 3.966-1.091c1.448 0 2.805.399 3.966 1.092Zm-3.966.16C3.625 3.757.699 6.683.699 10.27c0 3.587 2.926 6.513 6.513 6.513 3.587 0 6.513-2.926 6.513-6.513 0-3.587-2.926-6.513-6.513-6.513Zm3.567 6.224L9.612 11.36l.134 1.802a.626.626 0 0 1-.862.626l-1.672-.684-1.672.684a.625.625 0 0 1-.862-.626l.134-1.802-1.167-1.38a.626.626 0 0 1 .329-1.013l1.755-.43.95-1.536a.626.626 0 0 1 1.065 0l.951 1.537 1.755.43a.626.626 0 0 1 .33 1.012Z',
      fill: 'currentColor',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'tier-badge',
  type: 'solid'
}
